import { defineComponent as t, openBlock as n, createElementBlock as a, normalizeProps as s, guardReactiveProps as l, renderSlot as p } from "vue";
const u = /* @__PURE__ */ t({
  __name: "IstLabel",
  props: {
    for: {}
  },
  setup(e) {
    const o = e;
    return (r, c) => (n(), a("label", s(l(o)), [
      p(r.$slots, "default", {}, void 0, !0)
    ], 16));
  }
});
export {
  u as default
};
